import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useState } from 'react';
import AxiosConfig from '../../../../../config/AxiosConfig';

const OrderInvoices = ({ orderDetails }) => {
  const [displayInvoices, setDisplayInvoices] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleDisplayInvoices = () => {
    setDisplayInvoices(!displayInvoices);
  };

  const getInvoice = async () => {
    const response = await AxiosConfig.create(
      'get',
      `/orders/${orderDetails?.reference}/invoice`
    )
      .call()
      .getResponseData();
    return response;
  };

  const downloadPDF = (pdfData) => {
    // Decode base64 string
    const byteCharacters = atob(pdfData);
    const byteNumbers = new Array(byteCharacters.length);

    // Convert to byte array
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Create blob and download link
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `FACTURE-${orderDetails?.reference}.pdf`);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      const invoice = await getInvoice();
      downloadPDF(invoice);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!orderDetails?.paymentStatus?.bov2Code === 'payment_captured') {
    return null;
  }

  return (
    <Box>
      <Accordion elevation={6} disableGutters expanded={displayInvoices}>
        <AccordionSummary
          expandIcon={<ExpandMoreRoundedIcon onClick={handleDisplayInvoices} />}
          sx={{
            userSelect: 'text',
          }}
        >
          <Typography component={'span'} noWrap={true}>
            Facture
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {displayInvoices && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: 2,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
              }}
            >
              <Typography variant="subtitle1">
                {orderDetails?.reference}
              </Typography>
              <Button
                endIcon={
                  isLoading ? (
                    <CircularProgress size={10} />
                  ) : (
                    <DownloadRoundedIcon />
                  )
                }
                sx={{ fontSize: 11 }}
                variant="contained"
                color="primary"
                size="small"
                onClick={handleDownload}
                disabled={isLoading}
              >
                Télécharger
              </Button>
            </Box>
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default OrderInvoices;
